import { format, formatDistance } from 'date-fns';
import * as dateLocales from 'date-fns/locale';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function useDateLocale() {
  const { t } = useTranslation();
  const [locale] = t('translation:locale').split('-');
  return dateLocales[locale as keyof typeof dateLocales] || dateLocales.enGB;
}

export function useDateFormat() {
  const locale = useDateLocale();
  return useCallback(
    (date: Date | string, pattern: string): string =>
      format(date, pattern, { locale }),
    [locale],
  );
}

export function useDateFormatDistance() {
  const locale = useDateLocale();
  return useCallback(
    (date: Date | string, pattern: string): string =>
      formatDistance(date, pattern, { locale }),
    [locale],
  );
}

export default useDateFormat;
